import axios from './../utlis/axios';

/**
 * 首页banner
 */
export async function uploadImageApi(params) {
    try {
        let {data} = await axios.post('/api/v1/upload/image', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function getHomeBannerApi() {
    try {
        let {data} = await axios.get('/api/v1/banner')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取城市列表
 * @return {Promise<any[]>}
 */
export async function getCityListApi() {
    try {
        let {data} = await axios.get('/api/v1/city')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取推荐房源
 * @return {Promise<any[]>}
 */
export async function getRecommendHouseApi() {
    try {
        let {data} = await axios.get('/api/v1/recommend/house')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 推荐路线
 * @return {Promise<any[]>}
 */
export async function getRecommendLineApi() {
    try {
        let {data} = await axios.get('/api/v1/recommend/line')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取温泉酒店
 * @return {Promise<any[]>}
 */
export async function getSpringHouseApi() {
    try {
        let {data} = await axios.get('/api/v1/recommend/springHouse')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取客服信息
 * @return {Promise<any[]>}
 */
export async function getServiceInfoApi() {
    try {
        let {data} = await axios.get('/api/v1/service')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取标识符
 * @return {Promise<any[]>}
 */
export async function getIdentifiersApi() {
    try {
        let {data} = await axios.get('/api/v1/identifiers')
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 登录
 * @param params
 * @return {Promise<any[]>}
 */
export async function loginApi(params) {
    try {
        let {data} = await axios.post('/api/v1/account/login', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 注册
 * @param params
 * @return {Promise<any[]>}
 */
export async function registerApi(params) {
    try {
        let {data} = await axios.post('/api/v1/account/register', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 发送验证码
 * @param params
 * @return {Promise<any[]>}
 */
export async function sendCodeApi(params) {
    try {
        let {data} = await axios.post('/api/v1/account/sendCode', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取用户信息
 * @param params
 * @return {Promise<any[]>}
 */
export async function getUserInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/center', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取房源列表
 * @param params
 * @return {Promise<any[]>}
 */
export async function getLandlordApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/index', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 景点
 * @param params
 * @return {Promise<any[]>}
 */
export async function getSceneryApi(params) {
    try {
        let {data} = await axios.post('/api/v1/scenery', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 温泉
 * @param params
 * @return {Promise<any[]>}
 */
export async function getHotSpringApi(params) {
    try {
        let {data} = await axios.post('/api/v1/hotSpring', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 美食
 * @param params
 * @return {Promise<any[]>}
 */
export async function getCateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/cate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 路线
 * @param params
 * @return {Promise<any[]>}
 */
export async function getTouristSearchApi(params) {
    try {
        let {data} = await axios.post('/api/v1/touristSearch', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function getLandlordAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/add', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 房源退款规则
 * @param params
 * @return {Promise<any[]>}
 */
export async function getHouseRulesApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/houseRules', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取房源
 * @param params
 * @return {Promise<any[]>}
 */
export async function getlandlordIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/index', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 获取房屋详情
 * @param params
 * @return {Promise<any[]>}
 */
export async function getHouseDetailsApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/houseDetails', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 路线详情
 * @param params
 * @return {Promise<any[]>}
 */
export async function getTouristLookApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/touristLook', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function getDriverRulesApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/driverRules', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function hotSpringEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/hotSpring/evaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function sceneryEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/scenery/evaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function userSceneryApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/scenery', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function userHotSpringApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/hotSpring', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function userCateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/cate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function cateEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/cate/evaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function hotSpringAllEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/hotSpring/allEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function sceneryAllEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/scenery/allEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function cateAllEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/cate/allEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverCarSlipApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/slip', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverCarPlaneAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/planeAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 添加收款方式
 * @param params
 * @return {Promise<any[]>}
 */
export async function withdrawAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/withdrawAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 编辑收款方式
 * @param params
 * @return {Promise<any[]>}
 */
export async function withdrawEditApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/withdrawEdit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 查询收款方式
 * @param params
 * @return {Promise<any[]>}
 */
export async function fundsIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/fundsIndex', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 删除收款方式
 * @param params
 * @return {Promise<any[]>}
 */
export async function withdrawDelApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/withdrawDel', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function moneySelectApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/moneySelect', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function setMoneyApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/money', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 修改密码
 * @param params
 * @return {Promise<any[]>}
 */
export async function changePasswordApi(params) {
    try {
        let {data} = await axios.post('/api/v1/account/change/password', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 编辑用户信息
 * @param params
 * @return {Promise<any[]>}
 */
export async function datumEditApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/datumEdit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 用户消息
 * @param params
 * @return {Promise<any[]>}
 */
export async function userMessageApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/message', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 聊天消息
 * @param params
 * @return {Promise<any[]>}
 */
export async function socketSelectApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/socketSelect', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
/**
 * 聊天消息
 * @param params
 * @return {Promise<any[]>}
 */
export async function socketSelectaApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/socketSelecta', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function socketCacheApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/socketCache', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 收藏列表
 * @param params
 * @return {Promise<any[]>}
 */
export async function getCollectionApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/collection', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 收藏
 * @param params
 * @return {Promise<any[]>}
 */
export async function setCollectionApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/collection/method', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 需求
 * @param params
 * @return {Promise<any[]>}
 */
export async function planeIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/planeIndex', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 取消
 * @param params
 * @return {Promise<any[]>}
 */
export async function userBackMoneyApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/userBackMoney', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 我的订单
 * @param params
 * @return {Promise<any[]>}
 */
export async function userTrackAllApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/trackAll', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 我的评价
 * @param params
 * @return {Promise<any[]>}
 */
export async function myEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/myEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function houseManageApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/houseManage', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 发布房源
 * @param params
 * @return {Promise<any[]>}
 */
export async function addLandlordHouseApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/house', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function getEditHouseApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/edit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 编辑房源
 * @param params
 * @return {Promise<any[]>}
 */
export async function editHouseApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/editHouse', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 * 上下架
 * @param params
 * @return {Promise<any[]>}
 */
export async function houseDelectApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/houseDelect', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function hotSpringTypeApi(params) {
    try {
        let {data} = await axios.post('/api/v1/hotSpring/type', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function sceneryTypeApi(params) {
    try {
        let {data} = await axios.post('/api/v1/scenery/type', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function cateTypeApi(params) {
    try {
        let {data} = await axios.post('/api/v1/cate/type', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function hotSpringAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/hotSpring/add', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function sceneryAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/scenery/add', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function cateAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/cate/add', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function hotSpringInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/hotSpring', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function sceneryInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/scenery', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function cateInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/cate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

export async function editHotSpringApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/hotSpring/edit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

export async function editSceneryApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/scenery/edit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

export async function editCateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/cate/edit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function withdrawIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/withdrawIndex', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function moneyDetailApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/moneyDetail', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function fundsAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/fundsAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function houseEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/houseEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function allEvaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/allEvaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function landlordDataInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/dataInfo', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverDataInfoApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/dayMoney', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverTrackAllApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/trackAll', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverCarIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/index', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function driverCarAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/add', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function touristIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/touristIndex', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function touristAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/touristAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function carSingleApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/single', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function driverCarRushApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/rush', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function adviceAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/adviceAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function problemIndexApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/problemIndex', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function faqLogApi(params) {
    try {
        let {data} = await axios.post('/api/v1/faqLog', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function faqSerchApi(params) {
    try {
        let {data} = await axios.post('/api/v1/user/faqSerch', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function dymsOneApi(params) {
    try {
        let {data} = await axios.post('/api/v1/dymsOne', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function gywmApi(params) {
    try {
        let {data} = await axios.post('/api/v1/gywm', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function transApi(params) {
    try {
        let {data} = await axios.post('/api/v1/trans', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

/**
 *
 * @param params
 * @return {Promise<any[]>}
 */
export async function carEngineApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/engine', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordLandlordApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/landlord', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function getCouponApi(params) {
    try {
        let {data} = await axios.post('/api/v2/coupon', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function couponBuyApi(params) {
    try {
        let {data} = await axios.post('/api/v2/coupon/buy', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function couponPayApi(params) {
    try {
        let {data} = await axios.post('/api/v1/coupon/pay', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function carSlipAddApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/slipAdd', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function carPayApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/pay', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function touristEditApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/touristEdit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function calendarTouristApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/calendarTourist', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function engineDriverAddTouristApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/engineDriverAddTourist', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function engineDriverDelsTouristApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/engineDriverDelsTourist', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordCalendarApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/calendar', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordCalendarEditApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/calendarEdit', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function lineShelvessApi(params) {
    try {
        let {data} = await axios.post('/api/v1/driver/car/shelvess', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordMsgSendSaveApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/send', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function reserveRoomApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/reserveRoom', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordOrderApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/order', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordAcceptOrderApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/acceptOrder', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function landlordOrderComplainApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/orderComplain', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}

export async function landlordUserEvaluationApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/userEvaluation', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function evaluateApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/evaluate', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}
export async function orderLandlordCancelApi(params) {
    try {
        let {data} = await axios.post('/api/v1/landlord/cancel', params)
        return [null, data]
    } catch (e) {
        return [e, null]
    }
}



